import type { SVGProps } from "react";
const SvgBit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    fontSize="1rem"
    {...props}
  >
    <path
      fill="#FF073B"
      d="M6.5 12.834H2.571a.76.76 0 0 1-.555-.245.86.86 0 0 1-.23-.589.86.86 0 0 1 .23-.589.76.76 0 0 1 .555-.244H6.08l1.337-2.13a.8.8 0 0 1 .283-.272.75.75 0 0 1 .742 0 .8.8 0 0 1 .284.273l2.488 3.958.918-1.458a.8.8 0 0 1 .283-.273.75.75 0 0 1 .37-.098h2.358c.208 0 .408.088.555.244a.86.86 0 0 1 .23.59.86.86 0 0 1-.23.588.76.76 0 0 1-.555.245h-1.937l-1.338 2.129a.8.8 0 0 1-.283.273.75.75 0 0 1-.742 0 .8.8 0 0 1-.283-.273l-2.489-3.96-.917 1.458a.8.8 0 0 1-.283.273.75.75 0 0 1-.371.1M16.91 2c-2.027 0-3.803.925-4.91 2.489C10.893 2.925 9.117 2 7.09 2c-1.615.002-3.163.683-4.304 1.894S1.002 6.746 1 8.459v.234c.007.22.096.43.247.582a.76.76 0 0 0 .563.225.77.77 0 0 0 .549-.262.86.86 0 0 0 .212-.597v-.182a4.95 4.95 0 0 1 1.325-3.387A4.4 4.4 0 0 1 7.09 3.667c1.91 0 3.514 1.079 4.184 2.812.06.153.16.284.29.376a.75.75 0 0 0 .874 0 .83.83 0 0 0 .29-.376c.67-1.736 2.273-2.812 4.184-2.812a4.4 4.4 0 0 1 3.193 1.405 4.95 4.95 0 0 1 1.325 3.387c0 5.584-7.638 10.64-9.429 11.75-1.064-.657-4.187-2.709-6.549-5.439a.77.77 0 0 0-.545-.27.76.76 0 0 0-.566.22.86.86 0 0 0-.254.578.86.86 0 0 0 .206.6c3.061 3.541 7.163 5.904 7.336 6.003a.75.75 0 0 0 .744 0C12.806 21.653 23 15.75 23 8.459c-.002-1.713-.644-3.354-1.785-4.565S18.525 2.002 16.91 2"
    />
  </svg>
);
export default SvgBit;
